import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import playLogo from "styles/images/icons-video/play_button.svg";
import pauseLogo from "styles/images/icons-video/pause_button.svg";

export const PlayPauseLogo = ({ playingStatus }) => {
  const [button, setButton] = useState("");
  const [animate, setAnimate] = useState(true);
  useEffect(() => {
    switch (playingStatus) {
      case "play":
        handlePLay();
        break;
      case "pause":
        handlePause();
        break;
      default:
        break;
    }
  }, [playingStatus]);

  const handlePLay = () => {
    setButton("play");
    setAnimate(true);
    setTimeout(() => {
      /* c8 ignore next */
      setAnimate(false);
    }, 700);
  };
  const handlePause = () => {
    setButton("pause");
    setAnimate(true);
    setTimeout(() => {
      /* c8 ignore next */
      setAnimate(false);
    }, 500);
  };
  const renderButton = () => {
    switch (button) {
      case "play":
        return (
          <img
            src={playLogo}
            alt={"Play"}
            className={`ITXVideo__actionLogo  animation__zoom-disappear`}
          />
        );
      case "pause":
        return (
          <img
            src={pauseLogo}
            alt={"Pause"}
            className={`ITXVideo__actionLogo animation__zoom-disappear`}
          />
        );
      default:
        return null;
    }
  };
  return <>{animate && renderButton()}</>;
};
PlayPauseLogo.propTypes = {
  playingStatus: PropTypes.string.isRequired,
};
